var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('calendar-overview',{attrs:{"doctorId":_vm.doc.id,"animals":_vm.doc.animals,"types":_vm.doc.types}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }